<template>
  <div class="cuebiq-tab-content" id="attribution">
    <div class="cuebiq-panel">
      <div class="cuebiq-panel__heading">
        <h3 class="cuebiq-panel__title">Impression Delivery</h3></div>
      <div class="cuebiq-panel__body ">
        <div class="row">
          <div class="impression-geodistricts_distribution col-xs-7">
            <div class="cuebiq-section">
              <h4 class="cuebiq-section__title">Impression Distribution by Geographical districts
                <info-tooltip text="This map shows the amount of impressions delivered per geographical district.<br/>Hovering over a Geographical district will display the number of impressions delivered.<br/>Select one or multiple geographical districts to apply the filter.<br/>To remove filters use the status bar.">
                </info-tooltip>
              </h4>
              <div class="cuebiq-section__content">
                <dc-map v-if="impressions_map" v-bind="impressions_map" :width="550" :height="400"></dc-map>
              </div>
            </div>
          </div>
          <div class="impression-geodistricts_top10 col-xs-5">
            <div class="cuebiq-section">
              <h4 class="cuebiq-section__title">Top 10 Geographical Districts
                <info-tooltip text="The chart lists the Geographical districts where the highest number of impressions were served.">
                </info-tooltip>
              </h4>
              <div class="cuebiq-section__content">
                <div class="cuebiq-chart" id="districts-barchart">
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="cuebiq-separator">
        <div class="row">
          <div class="impression-timeline col-xs-9">
            <div class="cuebiq-section">
              <h4 class="cuebiq-section__title">Impression Timeline
                <info-tooltip text="This chart shows the amount of impressions delivered by day.<br/>Drag and drop to select a time interval.<br/>To remove filters, use the Status bar.">
                </info-tooltip>
              </h4>
              <div class="cuebiq-section__content">
                <div class="cuebiq-chart timeseries" id="impressions-timeline">
                </div>
              </div>
            </div>
          </div>
          <div class="impression-geotargetdelivery_assessment col-xs-3">
            <div class="cuebiq-section">
              <div class="cuebiq-section__content">
                <div class="cuebiq-section">
                  <h4 class="cuebiq-section__title">Geotargeting delivery assessment
                    <info-tooltip text="Split of impressions per type on delivery moment.<br/>Only the impressions that meet the geo-targeting criteria are studied in the visit analysis.<br/>Click one or more classes to apply the filter.<br/>To remove filters, use the Status bar.">
                    </info-tooltip>
                  </h4>
                  <div class="cuebiq-section__content">
                    <div>
                      <div>
                        <div class="cuebiq tooltip component  fixed-width" style="top: 0; left: 0;">
                          <div class="title">Title</div>
                          <ul></ul>
                        </div>
                      </div>
                      <div id="delivery-assessment-piechart" style="max-height: 210px; position: relative;">
                      </div>
                    </div>
                    <div id="pieGeoRefLegend" style="width: 100%;">
                      <ul class="labels-legend">
                        <li>Meets geo-targeting criteria<span style="width: 15px; height: 15px; display: inline-block; background-color: rgb(68, 154, 183);"></span></li>
                        <li>Doesn't meet geo-targeting criteria<span style="width: 15px; height: 15px; display: inline-block; background-color: rgb(123, 204, 196);"></span></li>
                        <li>Served within POI<span style="width: 15px; height: 15px; display: inline-block; background-color: rgb(224, 243, 219);"></span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="cuebiq-separator">
        <div class="row heatmap-impressions">
          <div class="impression-day_split col-xs-12">
            <div class="cuebiq-section">
              <h4 class="cuebiq-section__title">
                Split by Day
                <info-tooltip text="The chart illustrates how many impressions were delivered by day of the week.<br/>For campaigns running over multiple weeks, each bar is cumulative of all impressions delivered on the same day of the week.<br/>Click on one or more classes to apply filter.<br/>To remove filters, use the Status bar.">
                </info-tooltip>
              </h4>
              <div class="cuebiq-section__content">
                <div class="heatmap-block">
                  <div class="barchart-hours"></div>
                  <div class="heatmap"></div>
                  <div class="barchart-days"></div>
                </div>

                <div class="legend-container">
                  <div class="legend legend--heatmap">
                    <svg width="500" height="50">
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="impression-info_status status-bar " style="width: 1218px;">
      <ul class="kpis">
        <li class="id impressions" data-toast-model="impressions"><strong class="value filter-count"><dc-number v-if="delivered_impressions_number" v-bind="delivered_impressions_number"></dc-number> (<dc-number v-if="delivered_impressions_perc" v-bind="delivered_impressions_perc"></dc-number>)</strong><span class="key">Delivered<br>impressions</span></li>
        <li class="id reached" data-toast-model="reached"><strong class="value filter-count"><dc-number v-if="reached_devices_number" v-bind="reached_devices_number"></dc-number> (<dc-number v-if="reached_devices_perc" v-bind="reached_devices_perc"></dc-number>)</strong><span class="key">Reached devices<br>in current provinces</span></li>
      </ul>
      <section class="filters">
        <span class="resetall reset" v-on:click="resetFilters()" v-bind:class="{ active: allFilters.length }">reset all</span
        ><span class="resetlevel1 reset" v-on:click="resetFilters('impressionMap')" v-bind:class="{ active: filters.impressionMap.length }">provinces</span
        ><span class="resetlevel2 reset" v-on:click="resetFilters('districtsBarChart')" v-bind:class="{ active: filters.districtsBarChart.length }">counties</span
        ><span class="resettime reset" v-on:click="resetFilters('impressionTimeline')" v-bind:class="{ active: filters.impressionTimeline.length }">time</span
        ><span class="resettype reset" v-on:click="resetFilters('geoRefPieChart')" v-bind:class="{ active: filters.geoRefPieChart.length }">type</span
        ><span class="resetdayandhour reset" v-on:click="resetFilters('heatmapChartGroup')" v-bind:class="{ active: filters.heatmapChartGroup.length }">day and hour</span>
      </section>
    </section>
  </div>
</template>

<script>
import BarChart from '@/components/widgets/BarChart';
import LineChart from '@/components/widgets/LineChart';
import dc from 'dc';
import DcMap from '@/components/DcMap';
import DcNumber from '@/components/DcNumber';
import utils from '@/modules/utils';
import Heatmap from '@/modules/charts/heatmap';
import InfoTooltip from '@/components/widgets/InfoTooltip';

let crossfilter = dc.crossfilter;

  /* eslint-disable */
  export default {
    name: 'impressionAnalysis',
    components: {
      InfoTooltip,
      BarChart,
      LineChart,
      DcMap,
      DcNumber
    },
    data: function() {
      return {
        chartGroupName: 'impressionAnalysis',
        hasMissingDayHours: false,
        redrawState: {allow: false, done: false},

        deliveredImpressions: null,
        reachedDevices: null,

        impressions_map: null,

        delivered_impressions_number: null,
        delivered_impressions_perc: null,

        reached_devices_number: null,
        reached_devices_perc: null,

        dcCharts: {
          impressionMap: null,
          impressionTimeline: null,
          districtsBarChart: null,
          geoRefPieChart: null,
          heatmapChartGroup: []
        },

        filters: {
          impressionMap: [],
          impressionTimeline: [],
          districtsBarChart: [],
          geoRefPieChart: [],
          heatmapChartGroup: []
        }
      };
    },
    beforeRouteLeave(to, from, next) {
      this.$cursorSpinner.processing = false;
      next();
    },
    mounted: function () {
      //allowed because chart / display is static
      this.$reportSettings.setVisibility();
      this.fillData();
      this.$_am.logEvent("visit",this.$route.name,"impression-analysis",new Date().toISOString())
    },
    computed: {
      allFilters: function() {
        return this.filters.impressionMap.concat(
          this.filters.impressionTimeline,
          this.filters.districtsBarChart,
          this.filters.geoRefPieChart,
          this.filters.heatmapChartGroup
        );
      }
    },
    methods: {
      fillData: function() {
        var self = this;


        self.$dataStore.json('map.json', function(mapJson) {
          self.$dataStore.json('conversion_analysis_geo.json', function(conversionAnalysisJson) {
            self.$dataStore.json('conf.json', function(confJson) {
              self.deliveredImpressions = confJson["deliveredImpressions"];
              self.reachedDevices = confJson["reachedDevices"];

              self.$dataStore.csv('impressions_sampled.csv', function(impressionsCsv) {

                var earliestDate = null;
                var latestDate = null;

                impressionsCsv.forEach(function(d) {
                  d.datetime = d3.time.format("%Y-%m-%d %H").parse(d["time"]);
                  d.date = d3.time.day(d.datetime);

                  d.day = 6 - d.datetime.getDay();
                  d.hour = d.datetime.getHours() + 1;
                  d.value = confJson["sampleSize"];
                  d.delivered = confJson["deliveredImpressions"];


                  earliestDate = earliestDate && earliestDate < d.date ? earliestDate : d.date;
                  latestDate = latestDate && latestDate > d.date ? latestDate : d.date;
                });

                var result = (new Heatmap()).fillHoursDays(impressionsCsv)
                if (result.hasMissingDayHours) {
                  self.hasMissingDayHours = true
                  impressionsCsv = result.newDataset
                }

                var impressions = crossfilterAW(impressionsCsv, function() {
                  self.$cursorSpinner.processing = true;

                  if (self.redrawState.allow) {
                    dc.redrawAll(self.chartGroupName);
                    self.redrawState.done = true;
                  }

                  var resetCursorSpinner = function() {
                    if (self.redrawState.allow && self.redrawState.done)
                      self.$cursorSpinner.processing = false;
                  };

                  setTimeout(function(){
                    resetCursorSpinner();
                  }, 500);
                });

                self.$cursorSpinner.processing = true;
                self.initImpressionMap(impressions, mapJson);
                self.initImpressionTimeline(impressions, earliestDate, latestDate);
                self.initDistrictsBarChart(impressions);
                self.initGeoRefPieChart(impressions);
                self.initNumberDisplays(impressions, conversionAnalysisJson);
                self.initImpressionHeatmap(impressions);

              });
            });
          });
        });
      },

      initImpressionMap: function(impressionsCrossfilter, mapJson) {
        var self = this;

        var provinceDim = impressionsCrossfilter.dimension(function(d) { return d.admin1; });
        var impsPerProvince = provinceDim.group().reduceSum(function(d) { return d.value; });

        self.impressions_map = {
          dcGroup: self.chartGroupName,
          mapJson: mapJson,
          dimension: provinceDim,
          crossfilterGroup: impsPerProvince,
          enableOnInit: {render: false, legend: false},
          initFunc: function(dcMap, d3Legend, centerProjection, initLegend) {
            self.dcCharts.impressionMap = dcMap;

            impsPerProvince.$all().then(function(asyncResult) {
              var mostImpressions = asyncResult.data.sort((a,b) => parseFloat(b.value) - parseFloat(a.value))[0].value;
              var d3ColorRange = d3.scale.linear()
                .domain([0, (mostImpressions/3), 2*(mostImpressions/3), mostImpressions])
                .range(["lightgrey", "#69e4e8", "#1295C4", "#084081"])

              dcMap
                .filterHandler(self.customFilterHandler)
                .valueAccessor(function(d) { return Math.abs(Math.round(d.value)); })
                .colors(d3ColorRange)
                .title(function (d) {
                   return d.key + "\nImpressions: " + d3.format(".2s")(d.value ? d.value : 0);
                })
                .on('filtered', function(d) {
                  self.setOnFiltered('impressionMap', d);
                });

              dcMap.onClick = function(d, i) {
                var indexPosition = utils.indexPosition(asyncResult.data,d.properties.level1,"key")
                if (indexPosition > -1 && asyncResult.data[indexPosition]["value"] > 0) {
                  dc.events.trigger(function () {
                    dcMap.filter(d.properties.level1);
                    dcMap.redrawGroup();
                  });
                }
              };

              d3Legend
                .shapeWidth(30)
                .cells(asyncResult.data.length >= 5 ? 10 : 3)
                .labelFormat(function(d) {
                  return (d === 0 ? "0" : "<" + d3.format(".2s")(d) );
                });

              dcMap.render();

              initLegend(d3Legend);
              self.redrawState.allow = true;

              self.$reportSettings.setVisibility();
            });
          }
        };
      },

      initImpressionTimeline: function(impressionsCrossfilter, earliestDate, latestDate) {
        var self = this;

        var impressionTimeline = dc.lineChart("#impressions-timeline", self.chartGroupName);
        self.dcCharts.impressionTimeline = impressionTimeline;

        var dateDim = impressionsCrossfilter.dimension(function(d) { return d.date; });
        var impsPerDay = dateDim.group().reduceSum(function(d) { return d.value; });

        impsPerDay.$top(1).then(function(response) {
          var topValue = Math.round(response.data[0].value);

          impressionTimeline
            .width(720)
            .height(400)
            .dimension(dateDim)
            .filterHandler(self.customFilterHandler)
            .group({
              all: function() {
                // There might be gaps in the dates (days where there are no impressions).
                // This function fills those gaps with 0.

                var presentDates = impsPerDay.all();
                var allDates = [];

                function incrementDate(date) {
                  date.setDate(date.getDate() + 1);
                  return date;
                }

                for (var i = 0; i < presentDates.length; i++) {
                  allDates.push(presentDates[i]);

                  if (i === presentDates.length - 1)
                    break;

                  for (
                    var currentDate = incrementDate(new Date(presentDates[i].key));
                    currentDate < presentDates[i + 1].key;
                    currentDate = incrementDate(new Date(currentDate))) {

                    allDates.push({
                      key: currentDate,
                      value: 0
                    });

                  }
                }

                return allDates;
              }
            })
            .x(d3.time.scale().domain([earliestDate, latestDate]))
            .renderVerticalGridLines(true)
            .on('filtered', function(d) {
              self.setOnFiltered('impressionTimeline', d);
            })
            .y(d3.scale.linear().domain([0, Math.round(topValue)]))
            .yAxis().ticks(8).tickFormat(d3.format('.2s'));

          impressionTimeline.render();

          self.$reportSettings.setVisibility();
        });
      },

      initDistrictsBarChart: function(impressionsCrossfilter) {
        var self = this;

        var districtDim = impressionsCrossfilter.dimension(function(d) {
          return d['admin2'] + ', ' + d['admin1'];
        });
        var impsPerDistrict = districtDim.group().reduceSum(function(d) { return d.value });

        impsPerDistrict.$all().then(function(response) {
          var impsPerDistrictAll = response.data;
          var districtsBarChart = dc.rowChart("#districts-barchart", self.chartGroupName);
          self.dcCharts.districtsBarChart = districtsBarChart;

          var chartHeight = 400;
          var barWidth = 25;

          var numBars = Math.min(impsPerDistrictAll.length, 10);
          var gapSize = (chartHeight - 40 - numBars * barWidth)/(numBars + 1);

          districtsBarChart
            .fixedBarHeight(barWidth)
            .gap(gapSize)
            .width(420)
            .height(chartHeight)
            .cap(10)
            .othersGrouper(false)
            .valueAccessor(function(d) { return Math.abs(Math.round(d.value)); })
            .x(d3.scale.linear())
            .elasticX(true)
            .dimension(districtDim)
            .group(impsPerDistrict)
            .filterHandler(self.customFilterHandler)
            .labelOffsetX(-5)
            .label(function(d) {
              return utils.format.truncate(d.key, 18);
            })
            .title(function (d) {
              return d.key + "\nImpressions: " + d3.format(".2s")(d.value);
            })
            .on('filtered', function(d) {
              self.setOnFiltered('districtsBarChart', d);
            })
            .xAxis().ticks(3).tickFormat(d3.format('.2s'));

          districtsBarChart.margins().left = 100;
          districtsBarChart.on('pretransition', function(chart) {
            chart.selectAll('.row > text')
                .attr('text-anchor', 'end');
          });

          districtsBarChart.render();

          self.$reportSettings.setVisibility();
        });
      },

      initGeoRefPieChart: function(impressionsCrossfilter) {
        var self = this;

        var georefDim = impressionsCrossfilter.dimension(function(d) {return d.georef; });
        var impsPerGeoref = georefDim.group().reduceCount();
        var geoRefPieChartColors = {
          domain: ['C','N','G'],
          range: [d3.rgb(224, 243, 219), d3.rgb(123, 204, 196), d3.rgb(68, 154, 183)]
        };

        impsPerGeoref.$all().then(function(response) {
          var geoRefPieChart = dc.pieChart("#delivery-assessment-piechart", self.chartGroupName);
          self.dcCharts.geoRefPieChart = geoRefPieChart;

          geoRefPieChart
            .width(275)
            .height(210)
            .radius(90)
            .dimension(georefDim)
            .group(impsPerGeoref)
            .title(function(d) { return ""; })
            .externalRadiusPadding(5)
            .filterHandler(self.customFilterHandler)
            .colors(d3.scale.ordinal().domain(geoRefPieChartColors.domain).range(geoRefPieChartColors.range))
            .on('pretransition', function(chart) {
                chart.selectAll('text.pie-slice').text(function(d) {
                  var groupPercentage = Math.floor((d.endAngle - d.startAngle) / (2*Math.PI) * 100);
                  return groupPercentage < 5 ? "" : groupPercentage + '%';
                })
            })
            .on('filtered', function(d) {
              self.setOnFiltered('geoRefPieChart', d);
            })
            .render();

            self.$reportSettings.setVisibility();
          })
      },

      initNumberDisplays: function(impressionsCrossfilter, conversionAnalysisJson) {
        var self = this;

        var allDimension = impressionsCrossfilter.dimension(function(d) { return d; });
        var impsPerCurrentFilter = allDimension.group().reduceSum(function(d) { return d.value });

        self.delivered_impressions_number = {
          invalid_value: true,
          dcGroup: self.chartGroupName,
          dimension: allDimension,
          crossfilterGroup: impsPerCurrentFilter,
          numberFormat: function(d) {
            if (d === null || self.delivered_impressions_number.invalid_value) {
              return null;
            } else if (!d) {
              return "0";
            } else if (d < 1000) {
              return "<1k";
            } else {
              return d3.format(".3s")(d);
            }
          },
          valueAccessor: function(d) {
            if (d && typeof d.value !== 'undefined') {
              self.delivered_impressions_number.invalid_value = false;
              return Math.abs(Math.round(Number(d.value)));
            }
          }
        };

        self.delivered_impressions_perc = {
          invalid_value: true,
          dcGroup: self.chartGroupName,
          dimension: allDimension,
          crossfilterGroup: impsPerCurrentFilter,
          numberFormat: function(d) {
            if (d === null || self.delivered_impressions_perc.invalid_value) {
              return null;
            } else if (!d) {
              return "0%";
            } else if (d < 0.01) {
              return "<1%";
            } else {
              return d3.format(".0%")(d);
            }
          },
          valueAccessor: function(d) {
            if (d && typeof d.value !== 'undefined') {
              self.delivered_impressions_perc.invalid_value = false;
              var numImpressions = Math.abs(Math.round(Number(d.value)));
              return numImpressions/self.deliveredImpressions;
            }
          }
        };

        var provinceDim = impressionsCrossfilter.dimension(function(d) { return d.admin1; } );
        var provinceDimGroup = provinceDim.groupAll();


        var reachedDevicesPerProvince = provinceDimGroup.reduce(
          function reduceAdd(p, v, nf) {
            var province = v['admin1'];
            var provinceCount = (p.counts[province] || 0);

            if (!provinceCount) {
              p.total += p.reached_devices[province.toUpperCase()] || 0;
            }

            p.counts[province] = provinceCount + 1;

            return p;
          },

          function reduceRemove(p, v, nf) {
            var province = v['admin1'];
            var provinceCount = p.counts[province] - 1;

            if (!provinceCount) {
              p.total -= p.reached_devices[province.toUpperCase()] || 0;
            }

            p.counts[province] = provinceCount;

            return p;
          },

          function reduceInitial() {
            var p = {
              counts: {},
              reached_devices: {}, // per province
              total: 0
            };

            eval("conversionAnalysisJson.forEach(function(d) {\
              p.reached_devices[d['admin1']] = d['reached_devices'];\
            });")

            return p;
          },

          'var conversionAnalysisJson = ' + JSON.stringify(conversionAnalysisJson) +'; '
        );

        self.reached_devices_number = {
          invalid_value: true,
          dcGroup: self.chartGroupName,
          dimension: provinceDim,
          crossfilterGroup: reachedDevicesPerProvince,
          numberFormat: function(d) {
            if(d === null || self.reached_devices_number.invalid_value) {
              return null
            } else if (!d) {
              return "0";
            } else {
              return d3.format(".3s")(d);
            }
          },
          valueAccessor: function(d) {
            if (d && typeof d.total !== 'undefined') {
              self.reached_devices_number.invalid_value = false;
              return Math.min(d.total, self.reachedDevices);
            }
          }
        };

        self.reached_devices_perc = {
          invalid_value: true,
          dcGroup: self.chartGroupName,
          dimension: provinceDim,
          crossfilterGroup: reachedDevicesPerProvince,
          numberFormat: function(d) {
            if (d === null || self.reached_devices_perc.invalid_value) {
              return null;
            } else {
              return d3.format(".0%")(d);
            }
          },
          valueAccessor: function(d) {
            if (d && typeof d.total !== 'undefined') {
              self.reached_devices_perc.invalid_value = false;
              return Math.min(d.total, self.reachedDevices)/self.reachedDevices;
            }
          }
        };
      },

      initImpressionHeatmap: function(impressionsCrossfilter) {
        var _self = this;
        var sharedCrossfilter = impressionsCrossfilter;
        var blockContext = '.heatmap-impressions';

        var rangeWithoutZero = ['#e5e4e5', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081', '#063059', '#1C2B35'];
        var rangeWithZero = ['#8080801a', '#e5e4e5', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081', '#063059', '#1C2B35'];

        var heatmapImpressionsKlass = new Heatmap({
          enable_controls: true,
          crossfilter: sharedCrossfilter,
          chartGroupName: _self.chartGroupName,
          legend: {width: 400, shapeWidth: 40},
          colorScale: {
            heatmap: {
              range: _self.hasMissingDayHours ? rangeWithZero : rangeWithoutZero
            }
          }
        });

        heatmapImpressionsKlass.setHeatmapRowsLabel = function (i) {
          var _self = this;
          return _self.WDAY_LABELS[i === 6 ? 6 : 5 - i];
        };

        heatmapImpressionsKlass.getDimensions = function (crossfilter) {
          var ndx = sharedCrossfilter;

          return {
            day_hour: ndx.dimension((d) => { return [+d.hour, +d.day]; }),
            day: ndx.dimension((d) => { return +d.day; }),
            hour: ndx.dimension((d) => { return +d.hour; }),
          };
        };

        heatmapImpressionsKlass.getDayHourGroup = function(dimensions) {
          var _heatmapImpressionsKlass = heatmapImpressionsKlass;

          return dimensions.day_hour.group().reduce(
              /* callback for when data is added to the current filter results */
              function (p, v) {
                p.impCount += v.value;
                p.percentageGain = p.impCount;
                return p;
              },
              /* callback for when data is removed from the current filter results */
              function (p, v) {
                p.impCount -= v.value;
                p.impCount = d3.format(".2")(p.impCount) > 0 ? p.impCount : 0;
                p.percentageGain = p.impCount;
                return p;
              },
              /* initialize p */
              function () {
                return {impCount: 0, percentageGain: 0};
              }
          );
        };

        heatmapImpressionsKlass.getLegendTitle = function(d) {
          var percentLabel = d3.format(".2s")(d)
          return d === 0 ? percentLabel : "< " + percentLabel ;
        };

        heatmapImpressionsKlass.getHeatmapTitle = function(d) {
          var countInfo = d.value.impCount > 0 ? d3.format(".2s")(d.value.impCount) : '0' ;
          return "  Impressions:   " + countInfo;
        };

        heatmapImpressionsKlass.barchartsTitle = function(d) {
          var countInfo = d.value > 0 ? d3.format(".2s")(d.value) : '0' ;
          return "  Impressions:   " + countInfo;
        };

        heatmapImpressionsKlass.getBarchartDayTitle = heatmapImpressionsKlass.barchartsTitle;
        heatmapImpressionsKlass.getBarchartHourTitle = heatmapImpressionsKlass.barchartsTitle;


        heatmapImpressionsKlass.getColorDomain = function(dimensionGroupsDayHour) {
          return new Promise(function (resolve, reject) {

            var _heatmapImpressionsKlass = heatmapImpressionsKlass;

            var dimensions = _heatmapImpressionsKlass.getDimensions(sharedCrossfilter);
            var dimensionGroupsDayHour = _heatmapImpressionsKlass.getDayHourGroup(dimensions);

            var calculateScaleDomain = function (dimensionGroupsDayHourAll) {
              var data = dimensionGroupsDayHourAll.data.map((i) => {
                return i.value;
              });

              var max_day_hour = data.reduce((max, k) => {
                return k.impCount >= max.impCount ? k : max;
              });
              var min_day_hour = data.reduce((min, k) => {
                return k.impCount <= min.impCount ? k : min;
              });

              var colorDomain = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => {
                if (i === 0) {
                  return 0;
                } else if (i === 1) {
                  return min_day_hour.impCount
                } else {
                  return ((max_day_hour.impCount - min_day_hour.impCount) / 12) * (i + 2) + min_day_hour.impCount;
                }
              });

              _heatmapImpressionsKlass.scaleRange = _heatmapImpressionsKlass.scaleRange || {};
              _heatmapImpressionsKlass.scaleRange.minGain = colorDomain[1];
              _heatmapImpressionsKlass.scaleRange.maxGain = colorDomain[colorDomain.length - 1];

              resolve(colorDomain);
            };

            dimensionGroupsDayHour.$all().then(calculateScaleDomain);
          });

          //return colorDomain;
        };

        heatmapImpressionsKlass.getColorDomain().then(function(colorDomain) {
          heatmapImpressionsKlass.setColorScale = function() {
            var _self = this;
            var colorScale = _self.default.colorScale.heatmap;
            var hasColorScaleRangeOverride = _self.options.colorScale && _self.options.colorScale.heatmap && _self.options.colorScale.heatmap.range;

            if (hasColorScaleRangeOverride)
              colorScale.range =  _self.options.colorScale.heatmap.range;

            return d3.scale.linear()
              .domain(colorDomain)
              .range(colorScale.range);
          };

          let heatmapImpressionObj = heatmapImpressionsKlass.render(blockContext, [], colorDomain);


          _self.$reportSettings.setVisibility();

          //impression analysis bind
          _self.dcCharts.heatmapChartGroup.push(heatmapImpressionObj.chartGroup.heatmap);
          _self.dcCharts.heatmapChartGroup.push(heatmapImpressionObj.chartGroup.days);
          _self.dcCharts.heatmapChartGroup.push(heatmapImpressionObj.chartGroup.hours);


          heatmapImpressionObj.chartGroup.heatmap.filterHandler(_self.customFilterHandler);
          heatmapImpressionObj.chartGroup.days.filterHandler(_self.customFilterHandler);
          heatmapImpressionObj.chartGroup.hours.filterHandler(_self.customFilterHandler);


          window.legend = heatmapImpressionObj.legend;
          window.charts = heatmapImpressionObj.chartGroup;

          var setHeatmapFilterToTab = function(d) {
            _self.setOnFiltered('heatmapChartGroup', d);
          };

          heatmapImpressionObj.chartGroup.heatmap.on('filtered', setHeatmapFilterToTab);
          heatmapImpressionObj.chartGroup.days.on('filtered', setHeatmapFilterToTab);
          heatmapImpressionObj.chartGroup.hours.on('filtered', setHeatmapFilterToTab);
        });
      },

      setOnFiltered: function(chart, d) {
        var _self = this;
        _self.$cursorSpinner.processing = true;
        _self.filters[chart] = d.filters().slice();
      },

      resetFilters: function(chart) {
        var resetChartFilters = function(_chart) {
          if (_chart.constructor.toString().indexOf('Array') > -1) {
            _chart.forEach(function(chartChild) {
              chartChild.filterAll();
            });
          } else {
            _chart.filterAll();
          }
        };

        var self = this;

        if (!self.allFilters.length)
          return;

        if (!chart) {
          // reset all
          Object.keys(self.dcCharts).forEach(function(chart) {
            resetChartFilters(self.dcCharts[chart]);
          });
          dc.redrawAll(self.chartGroupName);
        } else if (self.filters[chart].length) {
          resetChartFilters(self.dcCharts[chart]);
          dc.redrawAll(self.chartGroupName);
        }
      },

      customFilterHandler: function (dimension, filters) {
        var rehydrateFilters = 'function(f) { \
          if(Array.isArray(f)) { \
            return dc.filters.RangedFilter(f[0],f[1]); \
          } else { \
            return f; \
          } \
        }';

        if (filters.length === 0) {
          dimension.filter(null);
        } else if (filters.length === 1 && !Array.isArray(filters[0])) {
          dimension.filterExact(filters[0]);
        } else if(filters.length === 1 && Array.isArray(filters[0]) &&
          filters[0].isFiltered &&
          typeof filters[0][0] === typeof filters[0][1]) {
          dimension.filterRange([filters[0][0], filters[0][1]]);
        } else {
          //replaced filters to a one character variable has variable name are compressed after transpilling
          dimension.filterFunction(function (d) {
            for (var i = 0; i < f.length; i++) {
              var filter = f[i];
              if (filter.isFiltered && filter.isFiltered(d)) {
                return true;
              } else if (filter <= d && filter >= d) {
                return true;
              }
            }
            return false;
          }, 'var f = ' + JSON.stringify(filters) + '.map(' + rehydrateFilters + ');')
        }
        return filters;
      },

    }
  };
</script>

<style lang="sass">
  @import '../../assets/css/charts/heatmap.scss'
  @import '../../assets/css/tabs/impression-analysis.scss'
</style>



// WEBPACK FOOTER //
// src/components/tabs/ImpressionAnalysis.vue